module.exports = __webpack_public_path__ + "assets/stemIcon2.06e347fc.svg";